import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import Swal from 'sweetalert2';
import { FieldConfig } from '../../_models/field.interface';
import { StatusMembro } from '../../_models/membro';
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { NavigationService } from '../../_services/navigation.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
})
export class IndexComponent implements OnInit {
  listaConteudos: any[] = [];
  listaConteudosMobile: any[] = [];
  niveis: any[] = [];
  exibirExplicacaoNiveis: boolean = false;
  resumoVencimentoCacaus: any = null;

  desafios: any[] = [];
  membro: any = undefined;
  notificacao: any;

  exibePopupAvisoHome: boolean = false;
  exibePopupAceiteComunicacao: boolean = false;
  exibeBotaoFecharAvisoHome: boolean = true;
  exibePopupAvisoVencimentoCacaus: boolean = true;
  exibePopupGanhadorPromocao: boolean = false;
  exibePopupNotificacao: boolean = false;

  regulamento: string = '';
  regAbrirFecharPopupAvisoHome: FieldConfig[] = [];
  regConfigPopupAceiteComunicacao: FieldConfig[];
  regConfigPopupRegulamento: FieldConfig[] = [];

  carregandoMembro: boolean = false;
  carregandoNiveis: boolean = false;
  carregandoConteudos: boolean = false;
  carregandoDesafios: boolean = false;

  returnUrl: string = '';

  public qtdCards: number;

  constructor(
    private navigationService: NavigationService,
    private fidelidadeService: FidelidadeService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.carregarMembroLogado();
    this.obterNiveis();
    this.buscarConteudos();
    this.obterDesafios();
    this.route.queryParams.subscribe((params) => {
      if (params.returnUrl) this.returnUrl = params.returnUrl;
      if (this.returnUrl !== '') this.router.navigate([this.returnUrl]);
    });
  }

  private carregarMembroLogado(): void {
    this.carregandoMembro = true;

    var membro = this.authService.LocalStorage.obterMembro();
    this.processarSucessoObterMembro(membro);
  }

  private processarSucessoObterMembro(res: any): void {
    this.membro = res;
    this.carregandoMembro = false;
    this.authService.LocalStorage.salvarNivel(res.idNivel);
    // if (this.membro?.tipoStatus === 7 || this.membro?.tipoStatus === 11) {
    //   this.router.navigate(['/meusdados']);
    // }

    if (this.membro.visualizarPopupHome) {
      this.mostrarPopupAvisoHome();
    } else if (this.membro.tipoStatus == StatusMembro.SEM_ACEITE_COMUNICACAO) {
      this.carregarAceiteComunicacao();
      this.exibePopupAceiteComunicacao = true;
    }

    this.carregarRegulamento();
    this.carregarAlertaVencimentoCacaus();
    this.obterNotificacoes();
  }

  private verificarGanhadorPromocao(): void {
    this.fidelidadeService.obterResultadoSorteio(2, this.membro.id).subscribe({
      next: () => (this.exibePopupGanhadorPromocao = true),
    });
  }

  private carregarAceiteComunicacao() {
    var nome =
      this.membro.nomeSocial != undefined && this.membro.nomeSocial != ''
        ? this.membro.nomeSocial
        : this.membro.nome;
    const labelAceiteComunicacao =
      'Olá ' +
      nome +
      ', \n\n Para continuar tendo acesso ao nosso site, assim como a nossas ofertas, promoções e preços exclusivos, preciso que você leia e aceite o novo regulamento javascript:abrirFecharPopupRegulamento(this,true) do programa Cacau Lovers. \n\n Dessa forma, a nossa relação continua sendo gostosa, assim como chocolate.';

    this.regConfigPopupAceiteComunicacao = [
      {
        type: 'label',
        label: labelAceiteComunicacao,
        style(): object {
          return {};
        },
      },
      {
        type: 'button',
        class: 'lovers-button',
        label: 'Aceitar os termos',
        style(): object {
          return {};
        },
        onClick: () => this.aceitarEnvioComunicacao(),
      },
    ];
  }

  private processarFalhaObterMembro(err: any): void {
    console.error('Ocorreu um erro ao obter o membro', err);
    this.carregandoMembro = false;
  }

  private carregarAlertaVencimentoCacaus() {
    // validar se o popup já foi exibido
    const exibido = this.authService.LocalStorage.obterAlertaVencimentoCacaus();

    if (exibido) return;

    this.fidelidadeService.obterResumoPontosAVencer().subscribe({
      next: (res: any) => this.processarSucessoObterAlertaVencimentoCacaus(res),
      error: (err: any) => {
        this.authService.LocalStorage.salvarAlertaVencimentoCacaus();
      },
    });
  }

  private processarSucessoObterAlertaVencimentoCacaus(obj: any) {
    this.exibePopupAvisoVencimentoCacaus = true;
    this.resumoVencimentoCacaus = obj;

    this.authService.LocalStorage.salvarAlertaVencimentoCacaus();
  }

  private obterNotificacoes(): void {
    this.fidelidadeService
      .obterNotificacaoNaoLidaPorIdMembroEIdNivel(
        this.membro.id,
        this.membro.idNivel
      )
      .subscribe({
        next: (res: any[]) => {
          if (res.length == 0) return;

          const grupoNotificacao = res[0];

          if (grupoNotificacao) {
            this.exibePopupNotificacao = true;
            this.notificacao = grupoNotificacao.notificacao;
            this.fidelidadeService
              .marcarNotificacaoComoLida(this.notificacao, this.membro.id)
              .subscribe();
          }
        },
        error: (err: any) => console.log(err),
      });
  }

  buscarConteudos() {
    this.carregandoConteudos = true;

    this.fidelidadeService.obterConteudoDosCarrosseisPorNivel().subscribe(
      (sucesso) => this.processarSucessoConteudo(sucesso),
      (falha) => this.processarFalhaConteudo(falha)
    );
  }

  processarSucessoConteudo(obj: any) {
    let indexLista = 1;
    const listaConteudos = obj[0].descontosParaLovers;

    for (let index = 0; index < listaConteudos.length; index++) {
      const element = listaConteudos[index];
      const customObj = {
        caminhoImagem: element.caminhoImagem,
        link: element.link,
        index: indexLista++,
      };

      const customObjMobile = {
        caminhoImagem: element.caminhoImagemMobile,
        link: element.link,
        index: indexLista++,
      };

      this.listaConteudos.push(customObj);
      this.listaConteudosMobile.push(customObjMobile);
    }

    this.carregandoConteudos = false;
  }

  processarFalhaConteudo(fail: any) {
    console.error(fail);
    this.carregandoConteudos = false;
  }

  obterNiveis() {
    this.carregandoNiveis = true;

    this.fidelidadeService.obterNiveis().subscribe(
      (res) => this.processarSucessoNiveis(res),
      (err) => this.processarFalhaNiveis(err)
    );
  }

  processarSucessoNiveis(res: any) {
    const niveis: any[] = res;

    for (let i = niveis.length - 1; i >= 0; i--) {
      let descricao = '';

      switch (niveis[i].nome.toLowerCase()) {
        case 'crush':
          descricao =
            'O Cacau Lover tem uma quedinha pela Cacau Show. Ele vem até a gente, faz charme, mas acaba levando produtos deliciosos para começar essa relação conosco.';
          break;
        case 'paquera':
          descricao =
            'O Cacau Lover voltou, o nosso primeiro encontro foi uma delícia. Agora ele quer conhecer a Cacau Show um pouco mais, estamos nos aproximando e está sendo muito gostoso.';
          break;
        case 'paixão':
          descricao =
            'O começo de um sonho. O Cacau Lover está apaixonado pela Cacau Show e por nossos produtos deliciosos, é aquela saudade que até dói se fica muito tempo sem se ver.';
          break;
        case 'amor':
          descricao =
            'O amor aconteceu! A intensidade desse relacionamento com a Cacau Show é muito forte, e mesmo nos conhecendo bem, prometemos surpreender sempre esse Cacau Lover mais que especial.';
          break;
      }

      this.niveis.push({ ...niveis[i], descricaoNivelPopup: descricao });
    }

    this.carregandoNiveis = false;
  }

  processarFalhaNiveis(err: any) {
    console.error('Ocorreu um erro ao obter os níveis', err);
    this.carregandoNiveis = false;
  }

  obterDesafios() {
    this.carregandoDesafios = true;

    this.fidelidadeService.obterDesafios(this.membro.cpf).subscribe({
      next: (res: any) => this.processarSucessoObterDesafios(res),
      error: (err: any) => this.processarFalhaObterDesafios(err),
    });
  }

  processarSucessoObterDesafios(res: any) {
    const desafios: any[] = [];

    res = _.orderBy(res, (desafio: any) => {
      return desafio.indexGrupoMissaoDependente;
    });

    var idsMissaoDependenteJaExibida = [];

    res.forEach((desafio: any) => {
      const desafioAceito = desafio.desafioAceito;
      const porcentagem = desafio.desafiosMembros[0]?.porcentagemFeita;

      const deasfioConcluido = desafioAceito && porcentagem >= 100;

      const dataSplit = desafio.dataFim.split('T')[0].split('-');
      const horaSplit = desafio.dataFim.split('T')[1].split(':');

      let exibeMissaoDependente = !desafio.idGrupoMissaoDependente;
      let countMissoesDependente = 0;
      let ehMissaoDependente = false;
      let listaMissoesDependente = [];
      if (
        desafio.idGrupoMissaoDependente != null &&
        desafio.idGrupoMissaoDependente != ''
      ) {
        if (
          !idsMissaoDependenteJaExibida.some(
            (x) => x == desafio.idGrupoMissaoDependente
          )
        ) {
          exibeMissaoDependente =
            porcentagem == undefined ? true : porcentagem < 100;
          listaMissoesDependente = res.filter(
            (x) => x.idGrupoMissaoDependente == desafio.idGrupoMissaoDependente
          );
          countMissoesDependente = listaMissoesDependente.length;
          if (exibeMissaoDependente) {
            idsMissaoDependenteJaExibida.push(desafio.idGrupoMissaoDependente);
            ehMissaoDependente = true;
          }
        }
      }

      const dataAtual = new Date().getTime();
      const dataFimDesafio = new Date(
        Number(dataSplit[0]),
        Number(dataSplit[1]) - 1,
        Number(dataSplit[2]),
        Number(horaSplit[0]),
        Number(horaSplit[1]),
        Number(horaSplit[2])
      ).getTime();

      if (
        !deasfioConcluido &&
        !(dataAtual >= dataFimDesafio) &&
        exibeMissaoDependente
      )
        desafios.push({
          id: desafio.id,
          titulo: desafio.nomeDesafio,
          descricao: desafio.descricao,
          valorPontosRecompensa: desafio.xp,
          valorCacausRecompensa: desafio.pontos,
          idTipo: desafio.idTipo,
          inicioDesafio: desafio.dataInicio,
          fimDesafio: desafio.dataFim,
          porcentagem: porcentagem,
          link: desafio.link !== null ? desafio.link : '',
          desafioAceito: desafioAceito,
          caminhoImagem: desafio.caminhoImagem,
          caminhoImagemMobile: desafio.caminhoImagemMobile,
          statusId: this.obterMissaoStatusId(desafio),
          descricaoDeAceite: desafio.descricaoDeAceite,
          countMissoesDependente: countMissoesDependente,
          idGrupoMissaoDependente: desafio.idGrupoMissaoDependente,
          ehMissaoDependente: ehMissaoDependente,
          indexGrupoMissaoDependente: desafio.indexGrupoMissaoDependente,
          listaMissoesDependente: listaMissoesDependente,
        });
    });

    this.desafios = _.orderBy(desafios, (desafio: any) => {
      return desafio.id;
    });

    if (
      this.desafios != null &&
      this.desafios != undefined &&
      this.desafios.length > 0
    )
      this.desafios = this.desafios.slice(0, 5);

    this.carregandoDesafios = false;
  }

  private obterMissaoStatusId(desafio: any) {
    const desafioConcluido =
      desafio.desafioAceito &&
      desafio.desafiosMembros[0].porcentagemFeita >= 100;

    let status: number = 0;

    if (desafioConcluido) status = 1;

    const dataSplit = desafio.dataFim.split('T')[0].split('-');
    const horaSplit = desafio.dataFim.split('T')[1].split(':');

    const dataAtual = new Date().getTime();
    const dataFimDesafio = new Date(
      Number(dataSplit[0]),
      Number(dataSplit[1]) - 1,
      Number(dataSplit[2]),
      Number(horaSplit[0]),
      Number(horaSplit[1]),
      Number(horaSplit[2])
    ).getTime();

    if (!desafioConcluido && dataAtual >= dataFimDesafio) status = 2;

    return status;
  }

  private processarFalhaObterDesafios(err: any): void {
    console.error('Ocorreu um erro ao boter os desafios', err);
    this.carregandoDesafios = false;
  }

  public aceitarDesafio(indexDesafio: number): void {
    this.desafios[indexDesafio].desafioAceito = true;
  }

  classeNivel(nivel: any): string {
    switch (nivel.nome) {
      case 'Amor':
        return 'nivel--amor';
      case 'Paixão':
        return 'nivel--paixao';
      case 'Paquera':
        return 'nivel--paquera';
      case 'Crush':
        return 'nivel--crush';
    }
  }

  abrirEntendaNiveis() {
    this.exibirExplicacaoNiveis = true;
  }

  mouseDown = false;
  startX: any;
  scrollLeft: any;
  slider = document.getElementById('desafios-cards');

  startDragging(e, flag, el) {
    this.mouseDown = true;
    this.startX = e.pageX - el.offsetLeft;
    this.scrollLeft = el.scrollLeft;
  }
  stopDragging(e, flag) {
    this.mouseDown = false;
  }
  moveEvent(e, el) {
    e.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    const x = e.pageX - el.offsetLeft;
    const scroll = x - this.startX;
    el.scrollLeft = this.scrollLeft - scroll;
  }

  mostrarPopupAvisoHome() {
    this.fidelidadeService
      .obterConfiguracaoPorDescricao('PopupAvisoHome')
      .subscribe(
        (sucesso) => {
          this.processarSucessoAvisoHome(sucesso);
        },
        (falha) => {
          this.processarFalhaAvisoHome(falha);
        }
      );
  }

  carregarRegulamento() {
    this.fidelidadeService
      .obterConfiguracaoPorDescricao('regulamento')
      .subscribe(
        (sucesso) => {
          this.processarSucessoRegulamento(sucesso);
        },
        (falha) => {
          this.processarFalhaRegulamento(falha);
        }
      );
  }

  processarSucessoAvisoHome(response: any) {
    var label: object = {
      'font-family': 'Sagona',
      'font-style': 'normal',
      'font-size': '14px',
      color: '#512111',
      height: '0px',
      float: 'left',
      'letter-spacing:': '-0.01em',
      'white-space': 'pre-line',
    };

    if (response.ativo) {
      var components = response.valor.split('Component');
      if (components != null && components.length > 1) {
        this.exibeBotaoFecharAvisoHome = false;
        for (let index = 0; index < components.length; index++) {
          if (components[index].includes('[LabelTitulo]')) {
            var texto = components[index].replace('[LabelTitulo] ', '');
            this.regAbrirFecharPopupAvisoHome.push({
              type: 'label',
              label: '\n' + texto,
              style(): object {
                return {
                  'font-size': '1.0em',
                  'font-weight': 'bolder',
                  display: 'block',
                  'text-align': 'center',
                };
              },
            });
          } else if (components[index].includes('[Label]')) {
            var texto = components[index].replace('[Label] ', '');

            this.regAbrirFecharPopupAvisoHome.push({
              type: 'label',
              label: texto,
              style(): object {
                return { 'font-size': '1.0em' };
              },
            });
          } else if (components[index].includes('[Checkbox-Aceite]')) {
            var texto = components[index].replace('[Checkbox-Aceite] ', '');
            this.regAbrirFecharPopupAvisoHome.push({
              type: 'checkbox',
              label: texto,
              class: 'checkbox_dados',
              value: false,
              name: 'checkboxAceite',
              styleLabelCheckBox(): object {
                return label;
              },
              onClick(): void {},
            });
          } else if (components[index].includes('[Botao-Confirmar]')) {
            var texto = components[index].replace('[Botao-Confirmar] ', '');
            this.regAbrirFecharPopupAvisoHome.push({
              type: 'buttonSubmit',
              label: texto,
              class: 'lovers-button',
              styleDivPrincipal(): object {
                return {
                  display: 'inline-block',
                  'margin-top': '25px',
                  width: '40%',
                  'margin-right': '25%',
                };
              },
              style(): object {
                return {};
              },
            });
          } else if (components[index].includes('[Botao-Cancelar]')) {
            var texto = components[index].replace('[Botao-Cancelar] ', '');
            this.regAbrirFecharPopupAvisoHome.push({
              type: 'button',
              label: texto,
              class: 'lovers-button',
              styleDivPrincipal(): object {
                return {
                  display: 'inline-block',
                  'margin-top': '25px',
                  width: '20%',
                };
              },
              style(): object {
                return {};
              },
              onClick: () => {
                this.sair();
              },
            });
          }
        }
      } else {
        this.regAbrirFecharPopupAvisoHome = [
          {
            type: 'label',
            label: '\n' + response.valor,
            style(): object {
              return { 'font-size': '1.0em', 'font-weight': 'bolder' };
            },
          },
        ];

        this.atualizarVisualizarPopupHome();
      }
    }

    this.exibePopupAvisoHome = true;
  }

  processarFalhaAvisoHome(fail: any) {
    this.exibePopupAvisoHome = false;
  }

  processarSucessoRegulamento(response: any) {
    this.regulamento = response.valor;

    var linhas = response.valor.split('\\n');

    for (let index = 0; index < linhas.length; index++) {
      if (linhas[index] == '\r') continue;

      if (index == 0) {
        this.regConfigPopupRegulamento.push({
          type: 'label',
          label: '\n' + linhas[index],
          style(): object {
            return { 'font-size': '1.5em', 'font-weight': 'bolder' };
          },
        });
      } else {
        this.regConfigPopupRegulamento.push({
          type: 'label',
          label: '\n' + linhas[index],
          style(): object {
            return {};
          },
        });
      }
    }
  }

  processarFalhaRegulamento(fail: any) {
    console.error('erro: ', fail);
  }

  submit(value: any) {
    if (!value.checkboxAceite) {
      Swal.fire({
        text: 'Atenção!! Para continuar a navegar é necessário aceitar o regulamento!',
        icon: 'warning',
        confirmButtonColor: '#2d1708',
        confirmButtonText: 'Fechar',
      }).finally();
      {
      }
    } else {
      this.authService.getIPAddress().subscribe(
        (res) => {
          this.fidelidadeService
            .registrarLogAceiteRegulamento(
              res.ip,
              this.regulamento,
              this.membro.cpf
            )
            .subscribe(
              (sucesso) => {
                this.atualizarVisualizarPopupHome();
                this.exibePopupAvisoHome = false;
              },
              (falha) => {
                Swal.fire({
                  text: 'Desculpe! O sistema encontra-se indisponivel!',
                  confirmButtonColor: '#2d1708',
                  confirmButtonText: 'Fechar',
                }).finally();
                {
                }
              }
            );
        },
        (falha) => {
          Swal.fire({
            text: 'Desculpe! O sistema encontra-se indisponivel!',
            confirmButtonColor: '#2d1708',
            confirmButtonText: 'Fechar',
          }).finally();
          {
          }
        }
      );
    }
  }

  atualizarVisualizarPopupHome(): void {
    this.setarSenhaNull();
    this.membro.visualizarPopupHome = false;
    this.fidelidadeService
      .atualizarMembro(this.membro, this.membro.email ?? this.membro.cpf)
      .subscribe(
        (sucesso) => {
          this.authService.LocalStorage.salvarMembro(sucesso);
          /* */
        },
        (falha) => {
          console.error(falha);
        }
      );
  }

  setarSenhaNull() {
    this.membro.senha = null;
    this.membro.senhaConfirmacao = null;
  }

  sair() {
    this.authService.LocalStorage.desconectar();
    this.router.navigate(['/']);
  }

  // Popups
  mostrarPopupAceiteComunicacao() {
    this.exibePopupAceiteComunicacao = true;
  }

  fecharPopupAceiteComunicacao() {
    this.exibePopupAceiteComunicacao = false;
    this.sair();
  }

  public aceitarEnvioComunicacao() {
    this.setarSenhaNull();
    this.membro.tipoStatus = StatusMembro.ATIVO;
    this.membro.enviaComunicacao = true;
    this.fidelidadeService
      .atualizarMembro(this.membro, this.membro.email ?? this.membro.cpf)
      .subscribe(
        (sucesso) => {
          this.authService.LocalStorage.salvarMembro(sucesso);
          this.exibePopupAceiteComunicacao = false;
        },
        (falha) => {
          Swal.fire({
            text: 'Desculpe! O sistema encontra-se indisponivel!',
            confirmButtonColor: '#2d1708',
            confirmButtonText: 'Fechar',
          }).finally();
        }
      );
  }

  public irParaVerDesafios(): void {
    this.navigationService.irParaPorLink('/desafios');
  }

  public irParaResultado(): void {
    this.navigationService.irParaLinkOuNavigate('/promocao');
  }

  public receberPopUpEntendaNiveis(respostaFilho) {
    this.exibirExplicacaoNiveis = respostaFilho;
  }

  public formatNumber(num: number): string {
    const numString = num?.toString();
    if (numString?.length <= 3) {
      return numString;
    }
    const separatorIndex = numString?.length - 3;
    return `${numString?.slice(0, separatorIndex)}.${numString?.slice(
      separatorIndex
    )}`;
  }

  public redirecionarMomentosEspeciais(cacaus: number): void {
    this.router.navigate(['/momentos-especiais'], {
      queryParams: { cacaus: cacaus },
    });
  }

  public onClickNotificacao(notificacao): void {
    if (!notificacao.linkBotao) return;

    if (notificacao.linkBotao.includes('http'))
      window.open(notificacao.linkBotao, '_blank');
    else this.router.navigate([notificacao.linkBotao]);
  }

  public quantidadeCardsProdutosCS(resultadoFiltro: {
    qtdProdutosCS: number;
  }): void {
    // const qtdCards = resultadoFiltro.qtdProdutosCS;
    this.qtdCards = resultadoFiltro.qtdProdutosCS;
  }
}
